import React from "react";
import DashboardLayout from "../../components/test/DashboardLayout";
import KPICards from "../../components/dashboard/KPICards";
import ProgramPerformanceChart from "../../components/dashboard/ProgramPerformanceChart";
import MostPurchasedProductsChart from "../../components/dashboard/MostPurchasedProductsCharts";
import ProductsAboutToExpireChart from "../../components/dashboard/ProductsAboutToExpireChart";
import RecentActivity from "../../components/dashboard/RecentActivity";
import CustomersWithMostPoints from "../../components/dashboard/CustomersWithMostPoints";
import QuickActions from "../../components/dashboard/QuickActions";
import {useParams} from "react-router-dom";

function HomePage() {
    const {userId, businessId} = useParams();

    return (
        <DashboardLayout userId={userId} businessId={businessId}>
            <h1 className="text-3xl font-bold text-gray-800 mb-6">Overview</h1>

            {/* KPI Cards */}
            <KPICards />

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-8">
                {/* Program Performance Chart */}
                <div className="lg:col-span-2 space-y-3">
                    <ProgramPerformanceChart />
                    <MostPurchasedProductsChart />
                    <ProductsAboutToExpireChart />
                </div>

                {/* Recent Activity & Quick Actions */}
                <div className="flex flex-col gap-6">
                    <RecentActivity />
                    <CustomersWithMostPoints />
                    <QuickActions />
                </div>
            </div>
        </DashboardLayout>
    )
}

export default HomePage;